import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingsService } from '../../core/http/settings.service';
import { ReportService } from '../../core/http/report.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import * as _moment from 'moment';
import { MatTabChangeEvent } from '@angular/material/tabs';
const moment = _moment;
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  @ViewChild('table', { static: false }) table: ElementRef;

  // @Output() dateChange:EventEmitter< MatDatepicker <any>> = new EventEmitter();
  cacheKey = `this.emplyees`;
  isLoading = true;
  Errors = null;
  mode = 'view';
  emplyees: any = [];
  filterdPatient: any = [];
  titles: any = [];
  cities: any = [];
  states: any = [];
  socs: any = [];
  countries: any = [];
  drs: any = [];
  nations: any = [];
  barCodes: any = [];
  Branches: any = [];
  searchRef: any = [];
  data = null;
  refLoad: boolean = true;
  timer;
  drVisible: boolean = false;
  fileName = 'ExcelSheet.xlsx';
  refDrCode;
  refDrName;
  sex;
  date;
  startdate;
  enddate;
  st;
  dt;
  searchLoad = false;
  private _searchText: string = '';
  canDiscount = [];
  userId = localStorage.getItem('id');
  users: any;

  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterdPatient = this.filterEmployees(value);
  }

  filterEmployees(searchString: string) {
    return this.emplyees.filter(
      (employee) =>
        employee.first_name
          .toLowerCase()
          .indexOf(searchString.toLowerCase()) !== -1
    );
  }
  searchPatient(newValue) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.searchNewPatient(newValue);
    }, 1000);
  }
  serachAll() {
    this.searchLoad = true;
var cacheValue = localStorage.getItem(this.cacheKey);
    this.emplyees = cacheValue ? JSON.parse(cacheValue) : [];
    this.setting
      .getPatientsBySearch1(this.searchText, this.startdate, this.enddate, '')

      .subscribe(
        (resSuccess) => {
          this.emplyees = resSuccess;
          localStorage.setItem(this.cacheKey, JSON.stringify(this.emplyees));
          this.searchLoad = false;
          console.log(resSuccess);
        },
        (resErr) => {
          this.searchLoad = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }

  refchg(value) {
    if (value == '') {
      this.drVisible = false;
    } else {
      this.drVisible = true;
    }
    this.searchRef = this.drs.filter(
      (t) => t.Acount_Name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  searchNewPatient(newValue) {
    var cacheValue = localStorage.getItem(this.cacheKey);
    this.emplyees = cacheValue ? JSON.parse(cacheValue) : [];
    this.setting.getPatientsBySearch(newValue).subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        localStorage.setItem(this.cacheKey, JSON.stringify(this.emplyees));
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  stateForm = new FormGroup({
    registration_no: new FormControl(''),
    Branch_Code: new FormControl(''),
    registration_date: new FormControl(''),
    religion_code: new FormControl(''),
    occupation_code: new FormControl(''),
    title_id: new FormControl(''),
    first_name: new FormControl('', Validators.required),
    middle_name: new FormControl(''),
    father_name: new FormControl(''),
    sex: new FormControl('', Validators.required),
    marital_status: new FormControl('', Validators.required),
    bloodgroup: new FormControl(''),
    date_of_birth: new FormControl('', Validators.required),
    local_address1: new FormControl(''),
    local_address2: new FormControl(''),
    local_city: new FormControl(''),
    local_state: new FormControl(''),
    local_country: new FormControl(''),
    ref_doct_code: new FormControl('', Validators.required),
    nationality: new FormControl(''),
    mobile: new FormControl('', Validators.required),
    E_mail_address: new FormControl(''),
    country_of_birth: new FormControl(''),
    status: new FormControl(''),
    BlackListedPatient: new FormControl(''),
    Author_id: new FormControl(''),
    Entry_date: new FormControl(''),
    booking_number: new FormControl(''),
    User_Id: new FormControl(''),
    Password: new FormControl(''),
    Barcode_No: new FormControl(''),
    card_per: new FormControl(''),
    special_note: new FormControl(''),
    payor_code: new FormControl(''),
    age: new FormControl('', Validators.required),
    ageMonth: new FormControl(''),
    ageDays: new FormControl(''),
    numberOfChildren: new FormControl(''),
  });

  get formControls(): any {
    return this.stateForm['controls'];
  }

  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
    localStorage.setItem('startdate', this.startdate);
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
    localStorage.setItem('enddate', this.enddate);
    console.log(this.enddate);
  }

  DateChange(event: any) {
    const date = moment(event.target.value).format('YYYY/MM/DD');
    const dob_entry = moment(event.target.value).format('YYYY/MM/DD');
    const currentDate = moment(new Date()).format('YYYY/MM/DD');

    let split_dob = dob_entry.split('/');
    let splitCurrentDate = currentDate.split('/');
    let currentYear = +splitCurrentDate[0];
    let year = +split_dob[0];
    let age = currentYear - year;

    console.log('your age is' + age + 'which is' + currentYear + '+' + year);
    this.stateForm.patchValue({
      age: age,
      date_of_birth: moment(dob_entry).format('YYYY-MM-DDT23:00:00'),
    });
    console.log(new Date(dob_entry));

    this.date = '';
  }
  onChange(event: any) {
    const currentDate = moment(new Date()).format('YYYY/MM/DD');
    let splitCurrentDate = currentDate.split('/');
    let currentYear = +splitCurrentDate[0];
    let year = currentYear - event.target.value;
    // let formatYear = "01/01/" + year
    let formatYear = new Date(year, 1, 1);
    console.log(formatYear);
    // this.stateForm.patchValue({
    //   age: age,
    //   date_of_birth: new Date(formatYear),
    // });
    this.DateChange({ target: { value: new Date(formatYear) } });
    console.log(this.stateForm.value);
  }
  slectOnChange(event: any) {
    console.log(event.value);
    let titles = {};
    titles = this.titles.filter((t) => t.id == event.value);
    this.stateForm.patchValue({
      sex: titles[0].gender,
    });
    this.sex = titles[0].gender;

    console.log(this.stateForm.value);
  }

  refresh() {
    this.refLoad = true;
    this.searchRef = [];
    this.setting.getRefDr().subscribe(
      (resSuccess) => {
        this.refLoad = false;
        this.drs = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
        this.refLoad = false;
      }
    );
  }

  constructor(
    public router: Router,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public reportService: ReportService
  ) {}

  isEmail(email: string): boolean {
    var serchfind: boolean;

    const regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    serchfind = regexp.test(email);

    console.log(serchfind);
    return serchfind;
  }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;

    // if (this.stateForm.value.mobile[0] == '0') {
    //   this.stateForm.patchValue({
    //     mobile:
    //       '234' + this.stateForm.value.mobile.substring(1).replace(/\s+/g, ''),
    //   });
    // } else if (this.stateForm.value.mobile[0] == '+') {
    //   this.stateForm.patchValue({
    //     mobile: this.stateForm.value.mobile.substring(1).replace(/\s+/g, ''),
    //   });
    // } else if (this.stateForm.value.mobile.includes('234') == true) {
    //   this.stateForm.patchValue({
    //     mobile: this.stateForm.value.mobile.replace(/\s+/g, ''),
    //   });
    // } else {
    //   this.stateForm.patchValue({
    //     mobile: '234' + this.stateForm.value.mobile.replace(/\s+/g, ''),
    //   });
    // }
    const {
      registration_no,
      Branch_Code,
      registration_date,
      religion_code,
      occupation_code,
      title_id,
      first_name,
      middle_name,
      father_name,
      sex,
      marital_status,
      bloodgroup,
      date_of_birth,
      local_address1,
      local_address2,
      local_city,
      local_state,
      local_country,
      ref_doct_code,
      nationality,
      mobile,
      E_mail_address,
      country_of_birth,
      status,
      BlackListedPatient,
      Author_id,
      Entry_date,
      booking_number,
      User_Id,
      Password,
      Barcode_No,
      card_per,
      special_note,
      payor_code,
      age,
      ageMonth,
      ageDays,
      numberOfChildren,
    } = this.stateForm.value;
    console.log(this.stateForm.value);
    if (this.isEmail(E_mail_address) == false) {
      this.Errors = `Invalid email provided : ${E_mail_address}`;
      this.isLoading = false;
    } else {
      this.setting
        .postPatient(
          registration_no,
          Branch_Code,
          registration_date,
          religion_code,
          occupation_code,
          title_id,
          first_name,
          middle_name,
          father_name,
          sex,
          marital_status,
          bloodgroup,
          date_of_birth,
          local_address1,
          local_address2,
          local_city,
          local_state,
          local_country,
          ref_doct_code,
          nationality,
          mobile,
          E_mail_address,
          country_of_birth,
          status,
          BlackListedPatient,
          Author_id,
          Entry_date,
          booking_number,
          User_Id,
          Password,
          Barcode_No,
          card_per,
          special_note,
          payor_code,
          age,
          ageMonth,
          ageDays,
          numberOfChildren
        )
        .subscribe(
          (resSuccess) => {
            this.data = resSuccess;
            this.isLoading = false;
            console.log(resSuccess);

            if (this.data.success) {
              // this.closeModal()
              this.getPatients();
              this._snackBar.open('Saved Successfully', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
              window.location.reload();
            } else {
              this.isLoading = false;
              this.Errors = `Not Successful. ${this.data.message}`;
            }
          },
          (resErr) => {
            this.isLoading = false;
            this.Errors = resErr;
            console.log(resErr);
          }
        );
    }
  }
  getPatients() {
    var cacheValue = localStorage.getItem(this.cacheKey);
    this.emplyees = cacheValue ? JSON.parse(cacheValue) : [];
    this.setting.getPatientList().subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        localStorage.setItem(this.cacheKey, JSON.stringify(this.emplyees));
        this.filterdPatient = this.emplyees;
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }
  ngOnInit(): void {
    var cacheValue = localStorage.getItem(this.cacheKey);
    this.emplyees = cacheValue ? JSON.parse(cacheValue) : [];
    this.isLoading = true;
    this.setting.getPatientList().subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        localStorage.setItem(this.cacheKey, JSON.stringify(this.emplyees));
        this.filterdPatient = this.emplyees;
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );

    this.setting.getUser().subscribe(
      (resSuccess: any) => {
        this.users = resSuccess.filter((t) => t.CanAuthDiscount == true);
        this.canDiscount = this.users.filter(
          (t) => t.Employee_id === +this.userId
        );
        console.log(this.canDiscount, 'Dissssssssssssssss');
      },
      (resErr) => {
        // this.isLoading = false;
        // this.Errors = resErr;
      }
    );

    this.setting.getTitle().subscribe(
      (resSuccess) => {
        this.titles = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.setting.getCity().subscribe(
      (resSuccess) => {
        this.cities = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.setting.getState().subscribe(
      (resSuccess) => {
        this.states = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.setting.getcountry().subscribe(
      (resSuccess) => {
        this.countries = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.setting.getRefDr().subscribe(
      (resSuccess) => {
        this.drs = resSuccess;
        this.refLoad = false;
      },
      (resErr) => {
        this.refLoad = false;
        this.Errors = resErr;
      }
    );
    this.setting.getNation().subscribe(
      (resSuccess) => {
        this.nations = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.setting.getSalesCard().subscribe(
      (resSuccess) => {
        this.barCodes = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.setting.getBranches().subscribe(
      (resSuccess) => {
        this.Branches = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.setting.getSocs().subscribe(
      (resSuccess) => {
        this.socs = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  bill(patient) {
    this.auth.currentPatient(patient);
    this.router.navigateByUrl('/billing');
  }
  back() {
    this.mode = 'view';
  }

  setRefDr(dr) {
    this.refDrCode = dr.ref_doctor_code;
    this.refDrName = dr.Acount_Name;
    console.log(dr);

    this.drVisible = false;
    this.stateForm.patchValue({
      ref_doct_code: dr.ref_doctor_code,
    });
    console.log(this.stateForm.value);
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.index === 0) {
      console.log('Oneeeeeeeee');
      this.mode = 'view';
      // Handle tab 1 specific actions, if any
    } else if (event.index === 1) {
      console.log('twooooooooo');
      this.stateForm.patchValue({
        registration_no: '',
        Branch_Code: '',
        registration_date: '',
        religion_code: '',
        occupation_code: '',
        title_id: '',
        first_name: '',
        middle_name: '',
        father_name: '',
        sex: '',
        marital_status: '',
        bloodgroup: '',
        date_of_birth: '',
        local_address1: '',
        local_address2: '',
        local_city: '',
        local_state: '',
        local_country: '',
        ref_doct_code: '',
        nationality: '',
        mobile: '',
        E_mail_address: '',
        country_of_birth: '',
        status: '',
        BlackListedPatient: '',
        Author_id: '',
        Entry_date: '',
        booking_number: '',
        User_Id: '',
        Password: '',
        Barcode_No: '',
        card_per: 0,
        special_note: '',
        payor_code: '',
        age: '',
        ageMonth: '',
        ageDays: '',
        numberOfChildren: '',
      });
    }
  }

  reset() {
    console.log('resettttttt');
    this.stateForm.patchValue({
      registration_no: '',
      Branch_Code: '',
      registration_date: '',
      religion_code: '',
      occupation_code: '',
      title_id: '',
      first_name: '',
      middle_name: '',
      father_name: '',
      sex: '',
      marital_status: '',
      bloodgroup: '',
      date_of_birth: '',
      local_address1: '',
      local_address2: '',
      local_city: '',
      local_state: '',
      local_country: '',
      ref_doct_code: '',
      nationality: '',
      mobile: '',
      E_mail_address: '',
      country_of_birth: '',
      status: '',
      BlackListedPatient: '',
      Author_id: '',
      Entry_date: '',
      booking_number: '',
      User_Id: '',
      Password: '',
      Barcode_No: '',
      card_per: 0,
      special_note: '',
      payor_code: '',
      age: '',
      ageMonth: '',
      ageDays: '',
      numberOfChildren: '',
    });
  }

  edit(patient) {
    this.mode = 'edit';
    console.log(patient);

    this.stateForm.patchValue({
      registration_no: patient.registration_no,
      Branch_Code: patient.Branch_Code,
      registration_date: patient.registration_date,
      religion_code: patient.religion_code,
      occupation_code: patient.occupation_code,
      title_id: patient.title_id,
      first_name: patient.first_name,
      middle_name: patient.middle_name,
      father_name: patient.father_name,
      sex: patient.sex,
      marital_status: patient.marital_status,
      bloodgroup: patient.bloodgroup,
      date_of_birth: patient.date_of_birth,
      local_address1: patient.local_address1,
      local_address2: patient.local_address2,
      local_city: patient.local_city,
      local_state: patient.local_state,
      local_country: patient.local_country,
      ref_doct_code: patient.ref_doct_code,
      nationality: patient.nationality,
      mobile: patient.mobile,
      E_mail_address: patient.E_mail_address,
      country_of_birth: patient.country_of_birth,
      status: patient.status,
      BlackListedPatient: patient.BlackListedPatient,
      Author_id: patient.Author_id,
      Entry_date: patient.Entry_date,
      booking_number: patient.booking_number,
      User_Id: patient.User_Id,
      Password: patient.Password,
      Barcode_No: patient.Barcode_No,
      card_per: 0,
      special_note: patient.special_note,
      payor_code: patient.payor_code,
      age: patient.age,
      ageMonth: patient.ageMonth,
      ageDays: patient.ageDays,
      numberOfChildren: patient.numberOfChildren,
    });
    this.refDrName = patient.Acount_Name;
    this.refDrCode = patient.ref_doct_code;

    console.log(this.stateForm.value);
  }
  editSoc(patient) {
    this.mode = 'edit-soc';
    console.log(patient);

    this.stateForm.patchValue({
      registration_no: patient.registration_no,
      Branch_Code: patient.Branch_Code,
      registration_date: patient.registration_date,
      religion_code: patient.religion_code,
      occupation_code: patient.occupation_code,
      title_id: patient.title_id,
      first_name: patient.first_name,
      middle_name: patient.middle_name,
      father_name: patient.father_name,
      sex: patient.sex,
      marital_status: patient.marital_status,
      bloodgroup: patient.bloodgroup,
      date_of_birth: patient.date_of_birth,
      local_address1: patient.local_address1,
      local_address2: patient.local_address2,
      local_city: patient.local_city,
      local_state: patient.local_state,
      local_country: patient.local_country,
      ref_doct_code: patient.ref_doct_code,
      nationality: patient.nationality,
      mobile: patient.mobile,
      E_mail_address: patient.E_mail_address,
      country_of_birth: patient.country_of_birth,
      status: patient.status,
      BlackListedPatient: patient.BlackListedPatient,
      Author_id: patient.Author_id,
      Entry_date: patient.Entry_date,
      booking_number: patient.booking_number,
      User_Id: patient.User_Id,
      Password: patient.Password,
      Barcode_No: patient.Barcode_No,
      card_per: 0,
      special_note: patient.special_note,
      payor_code: patient.payor_code,
      age: patient.age,
      ageMonth: patient.ageMonth,
      ageDays: patient.ageDays,
      numberOfChildren: patient.numberOfChildren,
    });
    this.refDrName = patient.Acount_Name;
    this.refDrCode = patient.ref_doct_code;

    console.log(this.stateForm.value);
  }

  exportAll(): void {
    this.reportService.exportData('patient');
  }
  exportCurrent(): void {
    /* table id is passed over here */
    let element = document.getElementById('table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);


  }
}
